import { render } from "./Temperature.vue?vue&type=template&id=608e30f4&scoped=true"
import script from "./Temperature.vue?vue&type=script&lang=js"
export * from "./Temperature.vue?vue&type=script&lang=js"

import "./Temperature.vue?vue&type=style&index=0&id=608e30f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608e30f4"]])

export default __exports__